import { DocumentServicesObject } from '@wix/document-services-types';
import {
  InstallOptions,
  InstallCallbacks,
} from '@wix/editor-platform-host-integration-apis';
import { createDependenciesDriver } from './appDependenciesDriver';
import * as unifiedComponents from './unifiedComponents/installation/addApps';
import { PlatformContext } from '../../types/platformApi';
import { HttpClient } from '@wix/http-client';

const installApps = (
  context: PlatformContext,
  documentServices: DocumentServicesObject,
  appDefinitionIds: string[],
  installOptions: InstallOptions,
  callbacks?: InstallCallbacks,
) => {
  return unifiedComponents.installApps(
    context,
    documentServices,
    appDefinitionIds,
    installOptions,
    callbacks,
  );
};

const installWithConsentModal = async (
  context: PlatformContext,
  documentServices: DocumentServicesObject,
  appDefinitionId: string,
  options: InstallOptions,
): Promise<void> => {
  await openConsentModal(
    documentServices.generalInfo.getMetaSiteId(),
    appDefinitionId,
  );

  await installApps(context, documentServices, [appDefinitionId], options);
};

const openConsentModal = async (
  metaSiteId: string,
  appDefinitionId: string,
) => {
  const { ClientSDK, Platform } = await import(
    '@wix/installation-manager-client-sdk'
  );
  const appInstaller = new ClientSDK({
    platform: Platform.EDITOR,
    metaSiteId,
    httpClient: new HttpClient(),
  });

  return new Promise((resolve, reject) => {
    appInstaller.installAppWithIntent({
      appDefId: appDefinitionId,
      onInstallationSuccess: resolve,
      onInstallationFail: reject,
      onInstallationCancel: reject,
      onInstallationWindowClosed: reject,
      intent: 'plugins',
    });
  });
};

export { createDependenciesDriver, installApps, installWithConsentModal };
